import { AxiosInstance } from 'axios';
import { apiRequest } from './apiRequest';
import { ApiResponse } from './types';

interface AvailableSlotsRequest {
  zip: string;
  service_ids: string[];
  date: string;
}

export interface AvailableSlot {
  datetime: string;
  providerId: string;
}

export type GetAvailableSlots = (
  data: AvailableSlotsRequest
) => Promise<ApiResponse<AvailableSlot[]>>;

const getAvailableSlots = (api: AxiosInstance): GetAvailableSlots => {
  return async (data: AvailableSlotsRequest) => {
    return apiRequest<AvailableSlot[]>(api, {
      method: 'GET',
      url: '/api/custom-booking/available-slots',
      params: data,
    });
  };
};

export default getAvailableSlots;